import { Chart } from 'chart.js'

// Shared by the public slim pack (app/frontend/packs/shared_report.js) AND the
// portal preview Stimulus controller (shared_report_chart_controller.js) so the
// create-form preview renders charts identical to the public recipient view.
// Options are set PER-CHART (not via global Chart.defaults) so calling this in
// the exhibitor portal cannot disturb the Reports Hub's Chartkick charts.
// Caller's bundle is responsible for registering Chart.js components.
export const PALETTE = ['#295D77', '#3F8DAA', '#5DA9C7', '#7DC0DA', '#A4D5E6', '#C5E2EC', '#1F4660', '#E8EBEB']

// Pinned chart chrome so the public recipient page (bare Chart.js defaults) and
// the authenticated create-form preview (where app-global Chart.defaults differ)
// render IDENTICALLY — true preview parity. A system font stack avoids depending
// on a webfont (Inter) the slim public pack doesn't load.
const CHART_FONT  = "system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
const TEXT_COLOR  = '#545868'
const GRID_COLOR  = 'rgba(0, 0, 0, 0.08)'

export function buildChart(canvas) {
  let payload
  try {
    payload = JSON.parse(canvas.getAttribute('data-chart-payload') || '{}')
  } catch (e) {
    return null // malformed payload — fail closed, render nothing
  }
  const type = canvas.getAttribute('data-chart-type') || 'bar'
  const indexAxis = canvas.getAttribute('data-chart-index-axis') || 'x'
  const valueAxis    = indexAxis === 'y' ? 'x' : 'y'
  const categoryAxis = indexAxis === 'y' ? 'y' : 'x'

  return new Chart(canvas.getContext('2d'), {
    type: type,
    data: {
      labels: payload.labels || [],
      datasets: (payload.datasets || []).map((ds, i) => ({
        backgroundColor: ds.backgroundColor || PALETTE[i % PALETTE.length],
        borderColor: ds.borderColor || PALETTE[i % PALETTE.length],
        fill: ds.fill || false,
        tension: 0.2,
        ...ds
      }))
    },
    options: {
      animation: false,
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: indexAxis,
      plugins: {
        // Belt-and-suspenders: disable datalabels explicitly. On the public page the
        // plugin isn't registered (harmless no-op); in the portal it's globally
        // registered, and this guarantees no data labels appear in the preview.
        datalabels: { display: false },
        legend: {
          display: (payload.datasets || []).length > 1,
          position: 'bottom',
          labels: { color: TEXT_COLOR, font: { family: CHART_FONT } }
        },
        tooltip: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          titleFont: { family: CHART_FONT },
          bodyFont:  { family: CHART_FONT }
        }
      },
      scales: {
        [categoryAxis]: {
          ticks: { color: TEXT_COLOR, font: { family: CHART_FONT } },
          grid:  { color: GRID_COLOR }
        },
        [valueAxis]: {
          beginAtZero: true,
          ticks: { color: TEXT_COLOR, precision: 0, font: { family: CHART_FONT } },
          grid:  { color: GRID_COLOR }
        }
        // NO onClick — no drilldown on the public/preview surface.
      }
    }
  })
}
